export const PROJECT_STATE = {
  firstFormSubmitted: "firstFormSubmitted",
  firstFormApproved: "firstFormApproved",
  secondFormSubmitted: "secondFormSubmitted",
  secondFormApproved: "secondFormApproved",
  projectRejected: "projectRejected",
  draft: "draft",
};
